import { useSelector } from 'react-redux'
import { currentBotConfigurationSelector } from '../selectors/currentBotConfigurationSelector'
import { BotConfiguration } from '@feedyou/schema'

export const useBotConfiguration = (): BotConfiguration | undefined => {
  return useSelector(currentBotConfigurationSelector)
}
